// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"268":"0ea42f663c215626","647":"f8c378769e9e711c"}[chunkId] + ".js";
};